import * as React from "react";

import {NavSection} from "#components/side-nav-page-layout-package/nav-links/index.ts";
import KhanmigoPromoMini from "#dashboard-promos-package/khanmigo-promo-mini.tsx";

import type {KhanmigoPromoSectionDetail} from "../homepage-data.ts";

const KhanmigoPromoSection = ({
    section,
}: {
    section: KhanmigoPromoSectionDetail;
}): React.ReactElement => {
    return (
        <NavSection label={section.label} tag="h2">
            <KhanmigoPromoMini />
        </NavSection>
    );
};

export default React.memo(KhanmigoPromoSection);
